<template>
	<div class="chat-modal">
		<FullBackdrop>
			<div class="container" v-if="chat.case=='modal_login'">
				<h3 class="modal-title">{{$t('modal_chat.login.title')}}</h3>
				<p class="content-text">
					{{$t('modal_chat.login.text', {username: model.username})}}
				</p>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
					<router-link
							class="action"
							:to="{ name: 'login' }"
						>
						<button>{{$t('modal_chat.login.button')}}</button>
					</router-link>
				</div>
			</div>
			<div class="container" v-if="chat.case=='modal_subscription'">
				<h3 class="modal-title">{{$t('modal_chat.subscription.title')}}</h3>
				<p class="content-text">
					{{$t('modal_chat.subscription.text', {username: model.username})}}
				</p>
				<div class="footer">
					<button class="cancel active" @click="cancelHandler">{{$t('tokens_modal.button_back')}}</button>
					<router-link
						class="action"
						:to="{ name: 'purchase.subscription', query: { plan: subscription_plans[0].id } }"
					>
						<button>{{$t('modal_chat.subscription.button')}}</button>
					</router-link>
				</div>
			</div>
		</FullBackdrop>
	</div>
</template>
<script>
import FullBackdrop from "./FullBackdrop";
export default {
  components: { FullBackdrop },
  props: {
    model: {
      type: Object,
      required: true,
    },
    chat: {
      type: Object,
      required: true,
    },
    subscription_plans: {
      type: Object,
      required: true,
    }
  },
  methods: {
    cancelHandler() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/variables";
@import "../styles/classes";

.chat-modal {
  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
      width: 500px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .content-text {
      font-weight: bold;
      text-transform: uppercase;
    }

    & .footer {
      display: flex;
      justify-content: end;

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }
    }
  }

  & button.cancel {
    @extend %fresh-btn;

    border-radius: 0.5rem;
  }

  & .error-message {
    color: red;
  }
}
</style>
